/**
 * An external courier - `FRONTEND.md` §9.786, on BACKEND.md §10A.438 F, owner O139.
 *
 * Somebody outside the restaurant (the owner's *"niečo ako Wolt"*) who sees the orders waiting for a courier, his
 * own orders and his earnings, and nothing of the restaurant's: the server refuses him on every endpoint not marked
 * for him, so the app must not offer him a screen whose reads would all be refused.
 *
 * **Read off the untyped session row**, as `alsoDrivesOf` is, because the generated client learns `isExternal` only
 * at the next regeneration. Only an explicit `true` is a courier - a server older than §10A.438 answers nothing, and
 * nothing is not a yes.
 */
export function isExternalOf(row: unknown): boolean {
  if (typeof row !== 'object' || row === null) return false
  return (row as Record<string, unknown>).isExternal === true
}

/** The one path an external courier's app opens on, and the only one it keeps him on. */
export const COURIER_HOME = '/driving'

/**
 * Where an external courier is sent when he opens a path: his home for anything else, nowhere for his home itself
 * (`null`). A restaurant's own staff are never moved.
 */
export function courierRedirect(isExternal: boolean, path: string): string | null {
  if (!isExternal) return null
  const bare = path.split(/[?#]/)[0] ?? ''
  return bare === COURIER_HOME ? null : COURIER_HOME
}
